import { put } from 'redux-saga/effects';
import { trackRedirectToNextgen } from '../actions';

export const action = 'REDIRECT_TO_NEXTGEN';

export default function* () {
  yield put({ ...trackRedirectToNextgen() });
}
